import { LoanApplicationBorrower } from "@eave/shared/types/api";

import APIClient from "web_modules/APIClient";

export interface AppDelta {
  borrower1_dependents_list_of_ages?: string | null;
  borrower2_dependents_list_of_ages?: string | null;
  borrower4_dependents_list_of_ages?: string | null;
  borrower8_dependents_list_of_ages?: string | null;
}

export const updateLoanApp = (appId: number, values: AppDelta): Promise<void> => {
  return APIClient.put(`/loan_applications/${appId}`, values);
};

export const updateBorrowerDependents = (
  appId: number,
  borrowerEntity: number,
  borrower: LoanApplicationBorrower,
  dependents: string,
): Promise<void> => {
  return APIClient.put(
    `/uw/loan_applications/${appId}/loan_application_borrowers/entity/${borrowerEntity}`,
    {
      borrower: {
        ...borrower,
        dependents_list_of_ages: dependents,
      },
    },
  );
};
